import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.552 4.757a1.62 1.62 0 0 1 1.27 0l8.973 3.806a1.52 1.52 0 0 1 .954 1.4c-.025 4.774-2 13.193-9.927 16.987a1.48 1.48 0 0 1-1.275 0c-7.927-3.8-9.9-12.218-9.922-16.992a1.52 1.52 0 0 1 .954-1.4l8.973-3.809v.005Zm1.905-1.494a3.24 3.24 0 0 0-2.54 0l-8.973 3.8A3.15 3.15 0 0 0 4 9.963C4.025 15 6.1 24.217 14.846 28.406a3.1 3.1 0 0 0 2.682 0C26.278 24.216 28.349 15 28.374 9.962a3.15 3.15 0 0 0-1.944-2.9Zm4.179 9.928a.814.814 0 1 0-1.149-1.152l-5.925 5.924-2.675-2.674a.812.812 0 0 0-1.148 1.148l3.25 3.25a.815.815 0 0 0 1.148 0l6.5-6.5Z"
    }, null, -1)
  ])))
}
export default { render: render }